import { Injectable } from '@angular/core';
import { Response, RequestOptionsArgs } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Api } from './api.service';
import { WhiteLabel } from '../entities/index';
import { Log } from '../utils/index';


@Injectable()
export class WhiteLabelService {
  constructor(protected http: Api) {}

  @Log('green')
  getAllWhiteLabels(): Observable<WhiteLabel[]> {
    return this.http.get('whitelabel')
      .map((response) => response.items);
  }

  @Log('green')
  get(id: number): Observable<WhiteLabel> {
    return this.http.get(`whitelabel/${id}`);
  }

  @Log('green')
  create(data: FormData): Observable<WhiteLabel> {
    return this.http.post('whitelabel/create', data, null, true);
  }

  @Log('green')
  update(
    id: number,
    data: FormData,
  ): Observable<WhiteLabel> {
    return this.http.put(`whitelabel/${id}`, data, null, true);
  }

  @Log('green')
  delete(id: number): Observable<Response> {
    return this.http.delete(`whitelabel/${id}`);
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/white-label.service.ts